import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { SERVER_URL } from '../../constants.js';
import { ClipLoader } from 'react-spinners';
import axios from 'axios';
const CreateProduct = ({ onCreate }) => {
  const [formData, setFormData] = useState({
    productCode: '',
    name: '',
    price: '',
    totalStock: '',
    originalPrice:'',
    discount:'',
    imgUrl: [],
    category: '',
    subcategory: '',
    discount: '',
    coupons: '',
    description: '',
    top: '',
  });
  const [imageUrls, setImageUrls] = useState([]);
  const [features, setFeatures] = useState(['']);
  const [manufacturers, setManufacturers] = useState(['']);
  const [variations, setVariations] = useState([{ size: '', color: '', stock: '' }]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  useEffect(() => {
    // Fetch category list from the API
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${SERVER_URL}/api/v1/category`);
        const response2 = await axios.get(`${SERVER_URL}/api/v1/subcategory`);
        const {n}=response2.data
        const uniqueSubcategories = [...new Set(n)];
        setSubcategories(uniqueSubcategories);
        console.log('234834384348343',n)
        if (!response.ok) throw new Error('Failed to fetch categories');
        
        const data = await response.json();
        
        // Extract the 'name' property from each category
        const categoryNames = data.data.map((category) => category.name);
        
   
        setCategories(categoryNames);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchCategories();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'unsigned_preset'); // Replace 'dummy_preset' with your Cloudinary preset
     console.log(formData)
    try {
      const response = await fetch('https://api.cloudinary.com/v1_1/dpgf1rkjl/image/upload', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) throw new Error('Image upload failed');

      const data = await response.json();
      setImageUrls((prev) => [...prev, { url: data.secure_url, id: data.public_id }]);
      console.log(data)
    } catch (err) {
      setError(err.message);
    }
  };
  const removeImage = (index) => {
    setImageUrls((prev) => prev.filter((_, i) => i !== index));
  };

  const handleDynamicFieldChange = (setter, values, index, value) => {
    const updatedValues = [...values];
    updatedValues[index] = value;
    setter(updatedValues);
  };

  const addDynamicField = (setter, values) => setter([...values, '']);

  const removeDynamicField = (setter, values, index) => setter(values.filter((_, i) => i !== index));

  const handleVariationChange = (index, field, value) => {
    const updatedVariations = [...variations];
    updatedVariations[index][field] = value;
    setVariations(updatedVariations);
  };

  const addVariation = () => setVariations([...variations, { size: '', color: '', stock: '' }]);

  const removeVariation = (index) => setVariations(variations.filter((_, i) => i !== index));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    const payload = {
      ...formData,
      imgUrl: imageUrls.map((img) => img.url),
      features,
      manufacturers,
      variations,
    };
    console.log(payload)
  
    try {
      const response = await fetch(`${SERVER_URL}/api/v1/product`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
  
      if (!response.ok) throw new Error('Network response was not ok');
  
      const { data } = await response.json();
      // onCreate(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(error.message);
    }
  
    // Reset the form
    setFormData({
      productCode: '',
      name: '',
      price: '',
      totalStock: '',
      imgUrl: [],
      category: '',
      originalPrice:'',
      discount:'',
      subcategory: '',
      discount: '',
      coupons: '',
      description: '',
      top: '',
    });
    setImageUrls([]);
    setFeatures(['']);
    setManufacturers(['']);
    setVariations([{ size: '', color: '', stock: '' }]);
  };
  

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <ClipLoader size={150} color={"#123abc"} loading={loading} />
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }
  return (
    <div className="relative p-10 py-14 bg-gradient-to-br from-purple-300 to-pink-300 rounded-lg shadow-lg max-w-xl mx-auto overflow-hidden z-10 mt-6 mb-6">
      <motion.h2 className="relative text-2xl font-bold mb-6 text-center text-indigo-800 tracking-wide z-10">
        Create New Product 🛒
      </motion.h2>
      <motion.form onSubmit={handleSubmit} className="space-y-5 z-20 bg-white bg-opacity-90 p-6 rounded-lg shadow-md">
        <div>
          <label className="block mb-1 font-semibold text-gray-800">Product Code</label>
          <input
            type="text"
            name="productCode"
            value={formData.productCode}
            onChange={handleChange}
            className="border border-gray-300 rounded-lg p-2 w-full"
            placeholder="Enter product code"
          />
        </div>

        <div>
          <label className="block mb-1 font-semibold text-gray-800">Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="border border-gray-300 rounded-lg p-2 w-full"
            placeholder="Enter product name"
          />
        </div>
        <div>
          <label className="block mb-1 font-semibold text-gray-800">Top Status</label>
          <select
            name="top"
            value={formData.top}
            onChange={handleChange}
            className="border border-gray-300 rounded-lg p-2 w-full"
          >
            <option value="">Select Status</option>
            <option value="topDeals">Top Deals</option>
            <option value="topSelling">Top Selling</option>
            <option value="topTrending">Top Trending</option>
            <option value="topFeatured">Top Featured</option>
            <option value="hotTrending">Hot Trending</option>
          </select>
        </div>

        <div>
          <label className="block mb-1 font-semibold text-gray-800">Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="border border-gray-300 rounded-lg p-2 w-full"
            placeholder="Enter product description"
          />
        </div>

        <div>
  <label className="block mb-1 font-semibold text-gray-800">Category</label>
  <select
    name="category"
    value={formData.category}
    onChange={handleChange}
    className="border border-gray-300 rounded-lg p-2 w-full text-black"
  >
    <option value="">Select Category</option>
    {categories.map((category) => (
      <option key={category.id} value={category.name}>
        {category}
      </option>
    ))}
  </select>
</div>

        <div>
          <label className="block mb-1 font-semibold text-gray-800">Subcategory</label>
          <select
            name="subcategory"
            value={formData.subcategory}
            onChange={handleChange}
            className="border border-gray-300 rounded-lg p-2 w-full"
          >
            <option value="">Select Subcategory</option>
            {subcategories.map((subcategory, index) => (
              <option key={index} value={subcategory}>
                {subcategory}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block mb-1 font-semibold text-gray-800">Price</label>
          <input
            type="number"
            name="price"
            value={formData.price}
            onChange={handleChange}
            className="border border-gray-300 rounded-lg p-2 w-full"
            placeholder="Enter price"
          />
        </div>
        <div>
          <label className="block mb-1 font-semibold text-gray-800">Original Price</label>
          <input
            type="number"
            name="originalPrice"
            value={formData.originalPrice}
            onChange={handleChange}
            className="border border-gray-300 rounded-lg p-2 w-full"
            placeholder="Enter Original price"
          />
        </div>
        <div>
          <label className="block mb-1 font-semibold text-gray-800">Discount</label>
          <input
            type="number"
            name="discount"
            value={formData.discount}
            onChange={handleChange}
            className="border border-gray-300 rounded-lg p-2 w-full"
            placeholder="Enter Discount"
          />
        </div>

        <div>
          <label className="block mb-1 font-semibold text-gray-800">Total Stock</label>
          <input
            type="number"
            name="totalStock"
            value={formData.totalStock}
            onChange={handleChange}
            className="border border-gray-300 rounded-lg p-2 w-full"
            placeholder="Enter total stock"
          />
        </div>

        <div>
          <label className="block mb-1 font-semibold text-gray-800">Images</label>
          <input
            type="file"
            onChange={handleImageUpload}
            className="border border-gray-300 rounded-lg p-2 w-full"
          />
          <div className="mt-2 flex flex-wrap gap-4">
            {imageUrls.map((img, index) => (
              <div key={index} className="relative">
                <img
                  src={img.url}
                  alt={`Uploaded ${index + 1}`}
                  className="w-24 h-24 object-cover rounded-lg border"
                />
                <button
                  type="button"
                  onClick={() => removeImage(index)}
                  className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1 text-xs"
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        </div>

        <div>
          <label className="block mb-1 font-semibold text-gray-800">Features 📋</label>
          {features.map((feature, index) => (
            <div key={index} className="flex items-center space-x-2">
              <input
                type="text"
                value={feature}
                onChange={(e) => handleDynamicFieldChange(setFeatures, features, index, e.target.value)}
                className="border border-gray-300 rounded-lg p-2 w-full"
                placeholder={`Feature ${index + 1}`}
              />
              <button
                type="button"
                onClick={() => removeDynamicField(setFeatures, features, index)}
                className="text-red-500 font-bold"
              >
                Remove
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={() => addDynamicField(setFeatures, features)}
            className="text-blue-500 font-bold mt-2"
          >
            Add Feature
          </button>
        </div>

        <div>
          <label className="block mb-1 font-semibold text-gray-800">Manufacturers 🏭</label>
          {manufacturers.map((manufacturer, index) => (
            <div key={index} className="flex items-center space-x-2">
              <input
                type="text"
                value={manufacturer}
                onChange={(e) => handleDynamicFieldChange(setManufacturers, manufacturers, index, e.target.value)}
                className="border border-gray-300 rounded-lg p-2 w-full"
                placeholder={`Manufacturer ${index + 1}`}
              />
              <button
                type="button"
                onClick={() => removeDynamicField(setManufacturers, manufacturers, index)}
                className="text-red-500 font-bold"
              >
                Remove
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={() => addDynamicField(setManufacturers, manufacturers)}
            className="text-blue-500 font-bold mt-2"
          >
            Add Manufacturer
          </button>
        </div>

        <div>
          <label className="block mb-1 font-semibold text-gray-800">Variations 🔄</label>
          {variations.map((variation, index) => (
            <div key={index} className="space-y-2">
              <input
                type="text"
                value={variation.size}
                onChange={(e) => handleVariationChange(index, 'size', e.target.value)}
                className="border border-gray-300 rounded-lg p-2 w-full"
                placeholder="Size"
              />
              <input
                type="text"
                value={variation.color}
                onChange={(e) => handleVariationChange(index, 'color', e.target.value)}
                className="border border-gray-300 rounded-lg p-2 w-full"
                placeholder="Color"
              />
              <input
                type="number"
                value={variation.stock}
                onChange={(e) => handleVariationChange(index, 'stock', e.target.value)}
                className="border border-gray-300 rounded-lg p-2 w-full"
                placeholder="Stock"
              />
              <button
                type="button"
                onClick={() => removeVariation(index)}
                className="text-red-500 font-bold"
              >
                Remove Variation
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={addVariation}
            className="text-blue-500 font-bold mt-2"
          >
            Add Variation
          </button>
        </div>

        <motion.button
          type="submit"
          className="w-full bg-indigo-600 text-white font-semibold px-4 py-2 rounded-lg shadow transition duration-200 hover:bg-indigo-700"
        >
          Create Product
        </motion.button>
      </motion.form>
    </div>
  );
};

export default CreateProduct;
